module.exports = __webpack_public_path__ + "img/right-arrow.fd5568b0.svg";